import { ACTION, chatIdType, ComaSeparatedValues, ICOMMAND, IKeyMaybeValue, IRESPONSE, RESULT } from "../cmd-protocol";
import {
  EnumBooleanStringified,
  EnumBooleanStringifiedExtended,
  EnumCurrency,
  EnumPlayerFormat,
  JSONString,
} from "../@types";

export type clientID = { clientID: string; _iid?: string };

export enum EnumClientStatusType {
  AUDIO_UNMUTED = "11",
  AUDIO_MUTED = "12",
  STREAM_STATS = "15",
  PLAYER_EVENT = "16",
  PAGE_HIDDEN = "20",
  PAGE_VISIBLE = "21",
  PROXY_STATE_INFO = "22",
  MEDIA_PLAYER_EVENT = "23",
  WEBRTC_STATS = "24",
}

export class CMDP_CSTATUS implements ICOMMAND {
  public action: ACTION = ACTION.CMDP_CSTATUS;
  public params: clientID & {
    statusCode: EnumClientStatusType;
    text: string;
  };
}

export class CMDP_CSTATUS_RESPONSE extends CMDP_CSTATUS implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: IKeyMaybeValue;
}

export type ChargeAmount = {
  value: number;
  caption1: string;
  caption2: string;
  exceedsLimitFor?: string[];
};

export type LimitRenewedIn = {
  days: number;
  hours: number;
  minutes: number;
};

export type PaymentMethod = {
  paytype: string;
  paymentString: string;
  isSelected: boolean;
  limitRemaining?: number;
  limitCurrency?: string;
  limitRenewedAt?: string;
  limitRenewedIn?: LimitRenewedIn;
  limitRenewedInText?: string;
};

export type ChargeInfo = {
  allowed: EnumBooleanStringifiedExtended;
  currency: EnumCurrency;
  autoCharge?: string;
  amounts?: ComaSeparatedValues<string>;
  chargeAmounts?: JSONString<ChargeAmount[]>;
  additionalCurrencies?: JSONString<{
    amounts: number[];
    currency: EnumCurrency;
  }>;
  methods?: JSONString<Map<string, PaymentMethod>>;
};

export class CMDP_CQUERY_CHARGE implements ICOMMAND {
  public action = ACTION.CMDP_CQUERY_CHARGE;
  public params: clientID;
}

export class CMDP_CQUERY_CHARGE_RESPONSE extends CMDP_CQUERY_CHARGE implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: ChargeInfo;
}

export type StreamSources = {
  dataURL: string;
  streamPriority: ComaSeparatedValues<EnumPlayerFormat>;
  width?: string;
  height?: string;
  fps?: string;
  quality?: string;
  mediaH5Live?: string;
  mediaHlsMobileUrl?: string;
  mediaHlsUrl?: string;
  mediaJpegUrl?: string;
  mediaJpegWsUrl?: string;
  mediaWebRtc?: string;
  mediaVideoSdk?: string;
  mediaRtmp?: string;
  mediaRtmpUrl?: string;
};

export class CMDP_CSTARTVIDEOPULL implements ICOMMAND {
  public action = ACTION.CMDP_CSTARTVIDEOPULL;
  public params: clientID;
}

export class CMDP_CSTARTVIDEOPULL_RESPONSE extends CMDP_CSTARTVIDEOPULL implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: StreamSources;
}

export class CMDC_CSTARTVIDEOPULL implements ICOMMAND {
  public action = ACTION.CMDC_CSTARTVIDEOPULL;
  public params: StreamSources;
}

export class CMDC_CSTOPVIDEOPULL implements ICOMMAND {
  public action = ACTION.CMDC_CSTOPVIDEOPULL;
  public params: clientID &
    chatIdType & {
      code: string;
      time?: string;
    };
}

export class CMDP_CSTARTAUDIOPULL implements ICOMMAND {
  public action = ACTION.CMDP_CSTARTAUDIOPULL;
  public params: clientID;
}

export class CMDP_CSTARTAUDIOPULL_RESPONSE extends CMDP_CSTARTAUDIOPULL implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: Pick<StreamSources, "dataURL" | "streamPriority">;
}

export class CMDC_CSTARTAUDIOPULL implements ICOMMAND {
  public action = ACTION.CMDC_CSTARTAUDIOPULL;
  public params: Pick<StreamSources, "dataURL" | "streamPriority">;
}

export class CMDC_CSTOPAUDIOPULL implements ICOMMAND {
  public action = ACTION.CMDC_CSTOPAUDIOPULL;
  public params: clientID &
    chatIdType & {
      code: string;
      time?: string;
    };
}

export class CMDP_CSTARTPREVIEW implements ICOMMAND {
  public action = ACTION.CMDP_CSTARTPREVIEW;
  public params: clientID;
}

export class CMDP_CSTARTPREVIEW_RESPONSE extends CMDP_CSTARTPREVIEW implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: StreamSources;
}

export class CMDC_CSTOPPREVIEW implements ICOMMAND {
  public action = ACTION.CMDC_CSTOPPREVIEW;
  public params: clientID &
    chatIdType & {
      code: string;
      time?: string;
    };
}

export class CMDP_CSTARTVIDEOPUSH implements ICOMMAND {
  public action = ACTION.CMDP_CSTARTVIDEOPUSH;
  public params: clientID & {
    flashclient: boolean;
  };
}

export class CMDP_CSTARTVIDEOPUSH_RESPONSE extends CMDP_CSTARTVIDEOPUSH implements ICOMMAND {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: Pick<
    StreamSources,
    "dataURL" | "width" | "height" | "mediaJpegWsUrl" | "streamPriority" | "mediaWebRtc" | "fps" | "quality"
  >;
}

export class CMDP_CSTOPVIDEOPUSH implements ICOMMAND {
  public action = ACTION.CMDP_CSTOPVIDEOPUSH;
  public params: clientID;
}

export class CMDP_CSTOPVIDEOPUSH_RESPONSE extends CMDP_CSTOPVIDEOPUSH implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: IKeyMaybeValue;
}

export class CMDC_CSTOPTEXT implements ICOMMAND {
  public action = ACTION.CMDC_CSTOPTEXT;
  public params: clientID &
    chatIdType & {
      code: string;
      time?: string;
    };
}

export class CMDP_CSTARTTEXT implements ICOMMAND {
  public action = ACTION.CMDP_CSTARTTEXT;
  public params: clientID;
}

export class CMDP_CSTARTTEXT_RESPONSE extends CMDP_CSTARTTEXT implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: IKeyMaybeValue;
}

export class CMDC_PUBLICCHAT implements ICOMMAND {
  public action = ACTION.CMDC_PUBLICCHAT;
  public params: clientID &
    chatIdType & {
      user: JSONString<{ userName: string }>;
      event: "entered" | "left";
    };
}

export class CMDP_CTIP implements ICOMMAND {
  public action = ACTION.CMDP_CTIP;
  public params: clientID & {
    cent: string;
    gift: ComaSeparatedValues<string>;
    currency: EnumCurrency;
  };
}

export class CMDP_CTIP_RESPONSE extends CMDP_CTIP implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: IKeyMaybeValue;
}

export class CMDP_CCHARGE implements ICOMMAND {
  public action = ACTION.CMDP_CCHARGE;
  public params: clientID & {
    amount: string;
    paytype?: string;
  };
}

export class CMDP_CCHARGE_RESPONSE extends CMDP_CCHARGE implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: {
    successfully: EnumBooleanStringified;
  };
}

export type clipSnapshot = {
  time: number;
  imgSrc: string;
};

export type clipStatus = {
  index: string;
  name: string;
  progress: number;
};

export class CMDC_CLIPSTATUS implements ICOMMAND {
  public action = ACTION.CMDC_CLIPSTATUS;
  public params: clientID & {
    status: JSONString<clipStatus[]>;
  };
}

export class CMDC_CLIP implements ICOMMAND {
  public action = ACTION.CMDC_CLIP;
  public params: clientID & {
    chatID: string;
    clipID: string;
    index: string;
    name: string;
    duration: string;
    price: string;
    currency: EnumCurrency;
    snapshots: JSONString<clipSnapshot[]>;
  };
}

export class CMDP_CGETCLIPS implements ICOMMAND {
  public action = ACTION.CMDP_CGETCLIPS;
  public params: clientID;
}

export class CMDP_CGETCLIPS_RESPONSE extends CMDP_CGETCLIPS implements IRESPONSE {
  public result: RESULT;
  public commands: CMDC_CLIP[];
  public values: {
    recordedSeconds?: "string";
  };
}

export class CMDP_CBUYCLIP implements ICOMMAND {
  public action = ACTION.CMDP_CBUYCLIP;
  public params: clientID & {
    clipID: string;
  };
}

export class CMDP_CBUYCLIP_RESPONSE extends CMDP_CBUYCLIP implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: IKeyMaybeValue;
}
